import React from "react";
import { Form } from "react-bootstrap";
import { formatoNumero } from "../utils/moneda";

/** Valor sentinela para la opción "Total" (suma de todas las cuentas del usuario). */
export const TOTAL_CUENTA_ID = "total";

/** Selector de cuenta bancaria activa, usado en Gastos/Ingresos/Dashboard. */
export default function SelectorCuenta({ cuentas, cuentaId, onChange }) {
  if (!cuentas?.length) return null;

  return (
    <Form.Select
      value={cuentaId || ""}
      onChange={(e) => onChange(e.target.value === TOTAL_CUENTA_ID ? TOTAL_CUENTA_ID : Number(e.target.value))}
      style={{ maxWidth: 480 }}
      className="mb-3"
    >
      <option value={TOTAL_CUENTA_ID}>Total — todas las cuentas</option>
      {cuentas.map((c) => {
        const detalle = c.tipo === "TarjetaCredito"
          ? `usado ${c.simbolo}${formatoNumero(c.saldoActual)} / ${c.simbolo}${formatoNumero(c.limiteCredito || 0)}`
          : `${c.simbolo}${formatoNumero(c.saldoActual)}`;
        return (
          <option key={c.cuentaId} value={c.cuentaId}>
            {c.usuario ? `${c.usuario} — ` : ""}{c.tipo === "TarjetaCredito" ? "💳 " : ""}{c.banco} — {c.alias || c.moneda} ({detalle})
          </option>
        );
      })}
    </Form.Select>
  );
}
